import request from '@/utils/request'
import APIS from '@/permissions/index'
// 分页查询回款记录
export function getQueryCollections (params) {
  return request({
    ...APIS['@paymentRecord/GET_Query_Collections'],
    params
  })
}
// 编辑回款记录
export function updateCollection (data) {
  return request({
    ...APIS['@paymentRecord/Update_Collection'],
    data
  })
}
// 删除回款记录
export function deleteCollection (params) {
  return request({
    ...APIS['@paymentRecord/Delete_Collection'],
    params
  })
}

// 分页查询回款记录
export function exportCollections (params) {
  // const headers = {
  //   'Content-Type': 'application/octet-stream'
  // }
  // const responseType = 'arraybuffer'
  const responseType = 'blob'
  return request({
    ...APIS['@paymentRecord/Export_Collections'],
    params,
    responseType
  })
}

export function addCollection (data) {
  return request({
    ...APIS['@paymentRecord/Add_Collection'],
    data
  })
}
